export class WebhookV1RestoreJobRejectedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "userMessage",
            "baseName": "userMessage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1RestoreJobRejectedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
